import { createContext, useContext, FC } from "react";
import { Pack } from "lib/types";

type ActivePackContext = {
  activePack: Pack;
  setActivePack?: (pack: Pack) => void;
}

const ActivePackContext = createContext(null);

export const ActivePackProvider: FC<{ value: ActivePackContext }> = ({ value, children }) => {
  return <ActivePackContext.Provider value={value}>{children}</ActivePackContext.Provider>
};

export const useActivePackContext = () => useContext<ActivePackContext>(ActivePackContext);
